export default __webpack_public_path__ + "static/media/addi3.7e22a3c2.jpg";